import { render } from "./BubblebitDocsPage.vue?vue&type=template&id=467dd30e&scoped=true"
import script from "./BubblebitDocsPage.vue?vue&type=script&lang=js"
export * from "./BubblebitDocsPage.vue?vue&type=script&lang=js"

import "./BubblebitDocsPage.vue?vue&type=style&index=0&id=467dd30e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467dd30e"]])

export default __exports__